var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNoSearchResults = function SvgNoSearchResults(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0H72V72H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9D7F4",
    fillRule: "evenodd",
    d: "M53.02 31.47c0 10.844-8.64 19.632-19.296 19.632-10.658 0-19.296-8.788-19.296-19.631S23.066 11.84 33.724 11.84c10.655 0 19.295 8.788 19.295 19.63z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2672E9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M43.818 45.083L59.84 61.106"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EE55CA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M27.293 36l9-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.891,
    r: 1.5,
    fill: "#EE55CA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.7,
    cy: 25.891,
    r: 1.5,
    fill: "#EE55CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#2672E9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M51.02 29.47c0 10.844-8.64 19.632-19.296 19.632-10.658 0-19.296-8.788-19.296-19.631S21.066 9.84 31.724 9.84c10.655 0 19.295 8.788 19.295 19.63z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoSearchResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-search-results.55408e2e.svg";
export { ForwardRef as ReactComponent };